module.exports = __webpack_public_path__ + "static/media/mon-win-23.16185f1b.png";